import { Button } from '@eventbrite/design-ops-ds';
import { Icon } from '@eventbrite/eds-icon';
import { BoltFill } from '@eventbrite/eds-iconography';
import { Link } from '@eventbrite/eds-link';
import { gettext } from '@eventbrite/i18n';
import cx from 'classnames';
import React, { useState } from 'react';
import { useInterval } from 'react-use';
import { BenefitsList } from '../components/BenefitsList';
import { BlobSVG } from '../components/BlobSVG';
import { Illustrations } from '../components/Illustrations';
import { Timeline } from '../components/Timeline';
import '../styles/boostBenefits.scss';
import { BoostBenefitsProps } from '../types';

export const BoostBenefits: React.FC<BoostBenefitsProps> = ({
    CTAButtonText = gettext('Upgrade to Boost'),
    declineButtonText = gettext('No thanks'),
    ...props
}) => {
    const [activeIdx, setActiveIdx] = useState<number>(0);

    const intervalSpeed = props.static ? null : props.intervalSpeedMS || 3000;

    useInterval(() => {
        setActiveIdx((prevIdx) =>
            prevIdx < props.items.length - 1 ? prevIdx + 1 : 0,
        );
    }, intervalSpeed);

    const ctaButton = (
        <Button
            variant="primary"
            onClick={props.onCTAButtonClick}
            id="boost-benefits-primary-cta-button"
        >
            {CTAButtonText}
        </Button>
    );

    return (
        <div className={cx(['boost-benefits', { static: props.static }])}>
            <div className="boost-benefits__content">
                <div className="boost-benefits__content--left">
                    <Icon type={<BoltFill />} size="medium" />

                    <h1 className="heading">{props.headingContent}</h1>
                    <div className="boost-benefits__benefits-block">
                        <Timeline
                            items={props.items}
                            activeIdx={activeIdx}
                            static={props.static}
                        />
                        <BenefitsList items={props.items} />
                    </div>
                </div>
                <div className="boost-benefits__content--right">
                    <BlobSVG />
                    <Illustrations
                        items={props.items}
                        activeIdx={activeIdx}
                        staticIllustration={props.staticIllustration}
                    />
                </div>
            </div>

            <div className="boost-benefits__bottom-bar">
                {props.bottomBarContent}

                <div className="boost-benefits__bottom-bar--buttons">
                    <Button
                        variant="ghost"
                        onClick={props.onDeclineButtonClick}
                        id="boost-benefits-decline-button"
                    >
                        {declineButtonText}
                    </Button>
                    {props.bottomBarCTALink ? (
                        <Link to={props.bottomBarCTALink}>{ctaButton}</Link>
                    ) : (
                        ctaButton
                    )}
                </div>
            </div>
        </div>
    );
};
